import { TextInputComponent } from "components";
import { useDataProvider } from "../../../../providers";

export function PhoneNumberComponent() {
  const { dispatch, data } = useDataProvider();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    dispatch({
      type: "UPDATE_CUSTOMER_INFORMATION",
      value: {
        ...data.customerInformation,
        phoneNumber: e.currentTarget.value,
      },
    });
  }

  return (
    <TextInputComponent
      label="Phone Number"
      placeholder="Eg. 08123456789"
      onChange={handleChange}
      value={data.customerInformation?.phoneNumber ?? ""}
    />
  );
}
